// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-table[data-v-7f8bc211] {\n  padding-left: 10px;\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
